import { ListenerListDef } from "./ListenerListDef";

export class ListenerListDefUtil {
  public static getListName(name: string|ListenerListDef): string {
    if (typeof name === "object")
      return name.listName;
    return name;
  }
}